'use strict'

exports = module.exports = require('./commonjs/PhoneInputReactResponsiveUIDefaultMetadata').default

exports.PhoneInputNative = require('./commonjs/PhoneInputNativeDefaultMetadata').default

exports['default'] = require('./commonjs/PhoneInputReactResponsiveUIDefaultMetadata').default


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/index.commonjs.js
// module id = 2783
// module chunks = 0